import Vue from 'vue';
import VueRouter from 'vue-router';

import baseRoutes from './base.routes';
import adminPanelRoutes from './adminPanel.routes';
import projectRoutes from '../modules/projects/project.routes';
import projectListRoutes from '../modules/projects/projectsList.routes';
import authRoutes from './auth.routes';
import profileRoutes from './profile.routes';
import guestRoutes from './guest.routes';
import toolsRoutes from './tools.routes';

import {
  auth,
} from '@/plugins/firebase';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  ...baseRoutes,
  ...authRoutes,
  ...profileRoutes,
  ...guestRoutes,
  projectListRoutes,
  projectRoutes,
  adminPanelRoutes,
  toolsRoutes,
  {
    path: '*',
    redirect: {
      name: 'login',
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!auth.currentUser;
  const requireAuth = to.matched.some(record => !record.meta.authPage);
  if (requireAuth) {
    if (isAuthenticated) {
      const matchingRoles = to.matched.some((record) => {
        const { roles } = record.meta;
        return roles ? roles.some(item => store.state.user.roles.includes(item)) : true;
      });
      if (matchingRoles) {
        next();
      } else {
        next({
          name: 'dashboard',
        });
      }
    } else {
      next({
        name: 'login',
      });
    }
  } else if (isAuthenticated) {
    next({
      name: 'dashboard',
    });
  } else {
    next();
  }
});

export default router;
